import urlRegex from 'url-regex'
const regexURL = urlRegex();
export const newRegexpURL = new RegExp(regexURL.source + "|((@|＠)\\w+)|((#|＃)[^(\\s|#|＃|@|＠)]+)", "ig");

export const convUrl = (text) => {
  if (/^(#|＃)/.test(text)) {
    return "https://twitter.com/hashtag/" + text.replace(/#|＃/, "");
  } else if (/^(@|＠)/.test(text)) {
    return "https://twitter.com/" + text.replace(/@|＠/, "");
  }
  return text;
}

export const linked = (text) => {
  const list = [];
  let lastIndex = 0;
  let result;
  while((result = newRegexpURL.exec(text)) !== null) {
    list.push(text.slice(lastIndex, result.index))
    list.push({link: convUrl(result[0]), text: result[0]});
    lastIndex = newRegexpURL.lastIndex;
  }
  if (text.length !== lastIndex) {
    list.push(text.slice(lastIndex));
  }
  return list;
}
